import { instBundle } from '@/axios.js';
import moment from 'moment/moment';

const axiosAdmin2 = instBundle.axiosAdmin2;

const state = {
	beautyAwardList: [],
	firstCategoryList: [],
	secondCategoryList: [],
	thirdCategoryList: [],
	firstCategory: {},
	secondCategory: {},
	thirdCategory: {},
	mappingProduct: [],
};

const getters = {
	getAwardList: state => state.beautyAwardList,
	formatMappingProduct: state => {
		if (state.mappingProduct) {
			return state.mappingProduct.map(item => ({
				...item,
				startDate: moment(item.startDate, 'YYYYMMDD').format(
					'YYYY-MM-DD'
				),
				endDate: moment(item.endDate, 'YYYYMMDD').format('YYYY-MM-DD'),
			}));
		}
	},
	getFirstCategoryList: (state, _, rootState) => {
		if (state.firstCategoryList) {
			const updateList = state.firstCategoryList.map(item => {
				const path = JSON.parse(item?.doc);
				const updateItem = {
					...item,
					...(path && {
						imgPath: `${rootState.env.IMAGE_STORAGE_PATH}${path.moduleFirstCategoryFileDir}/${path.moduleFirstCategoryFileSaveName}`,
					}),
				};
				return updateItem;
			});
			return updateList;
		}
		return [];
	},
};

const mutations = {
	setData(state, data) {
		state.beautyAwardList = data;
	},
	setFirstCategory(state, data) {
		state.firstCategoryList = data;
	},
	setSecondCategory(state, data) {
		state.secondCategoryList = data;
	},
	setThirdCategory(state, data) {
		state.thirdCategoryList = data;
	},
	setFirstCategoryData(state, data) {
		state.firstCategory = data;
	},
	setSecondCategoryData(state, data) {
		state.secondCategory = data;
	},
	setThirdCategoryData(state, data) {
		state.thirdCategory = data;
	},
	setMappingProduct(state, data) {
		state.mappingProduct = data;
	},
};

const actions = {
	async setApiData({ commit }) {
		try {
			const { data } = await axiosAdmin2.get('/api/awards');
			commit('setData', data);
		} catch (err) {
			console.error(err);
		}
	},
	async getFirstCategory({ commit }, payload) {
		try {
			const {
				data: { categoryList },
			} = await axiosAdmin2.get(`/api/award/firstcategory/${payload}`);
			commit('setFirstCategory', categoryList);
		} catch (err) {
			console.error(err);
		}
	},
	async getSecondCategory({ commit }, { idHitProduct, idHitCategory }) {
		try {
			const {
				data: { secondCategoryList, hitCategory },
			} = await axiosAdmin2.get(
				`api/award/secondcategory/${idHitProduct}/${idHitCategory}`
			);
			commit('setSecondCategory', secondCategoryList);
			commit('setFirstCategoryData', hitCategory);
		} catch (err) {
			console.error(err);
		}
	},
	async getThirdCategory({ commit }, { idHitProduct, idHitCategory }) {
		try {
			const {
				data: { category1, category2, category3List },
			} = await axiosAdmin2.get(
				`api/award/thirdcategory/${idHitProduct}/${idHitCategory}`
			);
			commit('setThirdCategory', category3List);
			commit('setFirstCategoryData', category1);
			commit('setSecondCategoryData', category2);
		} catch (err) {
			console.error(err);
		}
	},

	async getMappinCategory({ commit }, { idHitProduct, idHitCategory }) {
		try {
			const {
				data: { categories, products },
			} = await axiosAdmin2.get(
				`api/award/thirdcategory/${idHitProduct}/${idHitCategory}/product-mappings`
			);
			commit('setFirstCategoryData', categories[0]);
			commit('setSecondCategoryData', categories[1]);
			commit('setThirdCategoryData', categories[2]);
			commit('setMappingProduct', products);
		} catch (err) {
			console.error(err);
		}
	},
};
export default { namespaced: true, state, mutations, actions, getters };
